<template>
  <el-tabs v-model="activeTab" @tab-click="onTab">
    <el-tab-pane label="司機" name="driver">
      <el-row :gutter="8">
        <el-col :span="12">
          <span>隊編/呼號: {{ vx_driverInfo.call_number }}</span>
        </el-col>
        <el-col :span="12">
          <span>車號: {{ vx_driverInfo.licence }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>狀態: {{ vx_driverInfo.status }}</span>
        </el-col>
        <el-col :span="12">
          <span>車齡: {{ vx_driverInfo.car_year }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>姓名: {{ vx_driverInfo.name }}</span>
        </el-col>
        <el-col :span="12">
          <span>性別: {{ vx_driverInfo.gender }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>廠牌: {{ vx_driverInfo.car_brand }}</span>
        </el-col>
        <el-col :span="12">
          <span>電話(帳號): {{ vx_driverInfo.account }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>可載人數: {{ vx_driverInfo.availableSeat }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>聯絡電話1: {{ vx_driverInfo.contact1 }}</span>
        </el-col>
        <el-col :span="12">
          <span>聯絡電話2: {{ vx_driverInfo.contact2 }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span>司機備註: {{ vx_driverInfo.note }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span>
            客服備註(乘客看不到): {{ vx_driverInfo.team_company_note }}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span>服務項目: {{ serviceStr }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="24">
          <span>軌跡更新時間: {{ vx_driverInfo.updated_at }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col v-loading="vx_isTabLoading" :span="24">
          <span v-if="vx_isTabLoading">地址: 搜尋地址中...</span>
          <span v-else>地址: {{ vx_driverTabAddr }}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-button
          size="large"
          type="primary"
          @click="recordPage(vx_driverInfo.id, '單一司機資料')"
        >
          司機資料編輯紀錄
        </el-button>
      </el-row>
    </el-tab-pane>
    <el-tab-pane label="排班站" name="shift">
      <el-row :gutter="8">
        <el-col :span="12">
          <span>排班站名稱: {{ vx_shiftInfo.name }}</span>
        </el-col>
        <el-col :span="12">
          <span>
            容納車輛數:
            {{ vx_shiftInfo.area_capacity }}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>
            排班時間1:
            {{ shiftPeriod1 }}
          </span>
        </el-col>
        <el-col :span="12">
          <span>
            排班時間2:
            {{ shiftPeriod2 }}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>備註: {{ vx_shiftInfo.note }}</span>
        </el-col>
      </el-row>
    </el-tab-pane>
    <el-tab-pane label="派遣區域" name="dispatch">
      <el-row :gutter="8">
        <el-col :span="12">
          <span>派遣區域名稱: {{ vx_dispatchInfo.name }}</span>
        </el-col>
        <el-col :span="12">
          <span>
            容納車輛數:
            {{ vx_dispatchInfo.area_capacity }}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>派遣策略: {{ vx_dispatchInfo.dispatch_strategy }}</span>
        </el-col>
        <el-col :span="12">
          <span>派遣排班站1: {{ vx_dispatchInfo.in_line_name1 }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="8">
        <el-col :span="12">
          <span>派遣排班站2: {{ vx_dispatchInfo.in_line_name2 }}</span>
        </el-col>
        <el-col :span="12">
          <span>備註: {{ vx_dispatchInfo.note }}</span>
        </el-col>
      </el-row>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { Notification } from 'element-ui'

export default {
  data() {
    return {
      activeTab: 'driver',
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('driverMonitor', {
      vx_fetchDriverTabAddr: 'fetchDriverTabAddr',
    }),
    ...mapMutations('driverMonitor', {
      vx_setActiveTab: 'setActiveTab',
    }),
    onTab() {
      this.vx_setActiveTab(this.activeTab)
      if (this.activeTab === 'driver') {
        this.vx_fetchDriverTabAddr()
      }
    },
    recordPage(id, type) {
      if (id) {
        this.$router.push({
          name: 'activityRecord',
          query: { id, type },
        })
      } else {
        Notification({
          title: '請選擇司機',
          type: 'warning',
        })
      }
    },
  },
  computed: {
    ...mapState('driverMonitor', {
      vx_driverInfo: 'driverInfo',
      vx_dispatchInfo: 'dispatchInfo',
      vx_shiftInfo: 'shiftInfo',
      vx_driverTabAddr: 'driverTabAddr',
      vx_isTabLoading: 'isTabLoading',
    }),
    serviceStr() {
      if (this.vx_driverInfo.service_list.length) {
        return this.vx_driverInfo.service_list
          .map((info) => info.name)
          .join(',')
      }
      return ''
    },
    shiftPeriod1() {
      return this.vx_shiftInfo.in_line_time1_start &&
        this.vx_shiftInfo.in_line_time1_end &&
        this.vx_shiftInfo.in_line_time1_start !== '' &&
        this.vx_shiftInfo.in_line_time1_end !== ''
        ? this.vx_shiftInfo.in_line_time1_start +
            '-' +
            this.vx_shiftInfo.in_line_time1_end
        : ''
    },
    shiftPeriod2() {
      return this.vx_shiftInfo.in_line_time2_start &&
        this.vx_shiftInfo.in_line_time2_end &&
        this.vx_shiftInfo.in_line_time2_start !== '' &&
        this.vx_shiftInfo.in_line_time2_end !== ''
        ? this.vx_shiftInfo.in_line_time2_start +
            '-' +
            this.vx_shiftInfo.in_line_time2_end
        : ''
    },
  },
  created() {
    this.unwatchTab = this.$store.watch(
      (state) => state.driverMonitor.activeTab,
      (newActiveTab) => {
        this.activeTab = newActiveTab
      },
    )
    this.unwatchDriverLat = this.$store.watch(
      (state) => state.driverMonitor.driverInfo.lat,
      () => this.vx_fetchDriverTabAddr(),
    )
  },
  beforeDestroy() {
    this.unwatchTab()
    this.unwatchDriverLat()
  },
}
</script>
<style scoped>
span {
  font-size: 16px;
}

.el-row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/driver-monitor-components-v2/Tab.vue